import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLabList } from "../../data/selectors/Lab/lab.selector";
import useLab from "../../data/talons/Lab/useLab";
import { color } from "../../utils/constant";
import { setTestData } from "../../data/reducers/LabTest/LabtestForm.reducer";
import { getTestData } from "../../data/selectors/LabtestForm/LabtestForm.seletor";
import { useLabtestForm } from "../../data/talons/Appointment/useLabtestForm";
import { useAppointmentForm } from "../../data/talons/Appointment/useAppointmentForm";
import { enqueueSnackbar } from "notistack";
import { size } from "lodash";

export default function LabTestForm(props) {
  const { appointmentId, selectedlabTest } = props;

  const { fetchLabList } = useLab();
  const testName = useSelector(getTestData);

  const labtestId = selectedlabTest?.filter(
    (item) => item?.lab_test_id !== undefined && item?.lab_test_id !== null
  );

  // const testId = selectedlabTest
  //   ?.filter((item) => item.id !== undefined && item.id !== null)
  //   ?.map((item) => item.id);

  const [SelectedName, setSelectedName] = useState([]);
  const labTest = useSelector(getLabList);

  useEffect(() => {
    fetchLabList({});
  }, [testName]);

  const { labTestEntry, labTestUpdate } = useLabtestForm();
  const { getAppointmentbyId } = useAppointmentForm();
  const dispatch = useDispatch();

  const handleCheckboxChange = (item, e) => {
    if (e.target.checked === true && !SelectedName?.includes(item)) {
      // Add selected test name
      setSelectedName((prev) => [...prev, item]);
    } else {
      // Remove unselected test name

      setSelectedName(() => SelectedName.filter((name) => name !== item));
      dispatch(setTestData(SelectedName));
    }
  };

  const onUserSubmit = useCallback(async () => {
    dispatch(setTestData(SelectedName));

    // if (size(SelectedName) > 0) {
    //   const res = await labTestUpdate(appointmentId, SelectedName);
    //   if (res === true) {
    //     await getAppointmentbyId(appointmentId);
    //     props.postSubmit();
    //   } else {
    //     enqueueSnackbar("Problem While Saving Lab test Data", {
    //       variant: "error",
    //     });
    //   }
    // } else {
    const res = await labTestEntry(appointmentId, SelectedName);

    if (res === true) {
      await getAppointmentbyId(appointmentId);
      props.postSubmit();
    } else {
      enqueueSnackbar("Problem While Saving Lab test Data", {
        variant: "error",
      });
      // }
    }
  }, [SelectedName]);

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Lab Test Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container fontWeight={"bold"} mb={3}>
        <Grid item xs={3} textAlign={"center"}>
          Action
        </Grid>
        <Grid item xs={4} sm={4} md={4} sx={{ ml: 3 }}>
          Test Name
        </Grid>
        <Grid item xs={3} sm={4} md={4} textAlign={"center"}>
          Price
        </Grid>
      </Grid>
      {labTest?.map((item) => {
        return (
          <Grid container>
            <Grid item xs={3} textAlign={"center"}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => handleCheckboxChange(item.id, e)}
                    sx={{
                      "&.Mui-checked": {
                        color: color.button,
                      },
                      mt: -1,
                    }}
                    id="is_labour"
                    checked={SelectedName?.find((id) => id === item.id)}
                  />
                }
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} sx={{ ml: 3 }}>
              {item.test_name}
            </Grid>
            <Grid item xs={3} sm={4} md={4} textAlign={"center"}>
              {item.price}
            </Grid>
          </Grid>
        );
      })}
      <Grid container direction="row" mt={4}>
        <Grid item xs={12} sm={12}>
          <Stack direction="row" justifyContent="end">
            <Button
              variant="contained"
              sx={{
                m: 1,
                backgroundColor: color.button,
                "&:hover": {
                  backgroundColor: color.button,
                },
              }}
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                onUserSubmit();
              }}
            >
              Save
            </Button>
            <Button
              sx={{
                m: 1,
                borderColor: color.button,
                color: color.button,
                "&:hover": {
                  color: color.button,
                },
              }}
              variant="outlined"
              onClick={(e) => {
                e.preventDefault();
                props.postSubmit();
              }}
            >
              Cancel
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
}
